import { FC } from 'react';
import { CartItemType } from '@base/cart/interface';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';

type ICartItemAvgPriceProps = {
    className?: string;
    item: CartItemType;
};

export const CartItemAvgPrice: FC<ICartItemAvgPriceProps> = props => {
    const { className, item } = props;
    const { t } = useTrans();

    return (
        <div className={cn(className, 'g-avg-price')}>
            {t('web_wholesale_30d_avg_price')}: {item.averagePrice.averagePrice30ExchangeDisplay}
        </div>
    )
};
